import api from './axiosConfig';
import { FilterValues } from '../types/dynamicTypes';

export interface EmployeePunchReportItem {
  employeeId: string;
  employeeCode: string;
  employeeName: string;
  date: string;
  checkInTime?: string | null;
  checkOutTime?: string | null;
  department?: string | null;
  departmentId?: string | null;
  organizationId?: string | null;
  modeOfEntry?: string | null;
  punchType?: string | null;
}

export interface MobileCheckinReportItem {
  employeeId: string;
  employeeCode: string;
  employeeName: string;
  checkinDate: string;
  punchTime?: string | null;
  deviceInfo: string;
  location: string;
  entityName?: string | null;
  entityType?: string | null;
  viewLocation?: string | null;
  remarks?: string | null;
}

const buildParams = (filters: FilterValues) => ({
  OrganizationId: filters.organizationId,
  EmployeeId: filters.employeeId,
  DepartmentId: filters.departmentId,
  StartDate: filters.startDate,
  EndDate: filters.endDate,
  ModeOfEntry: filters.modeOfEntry,
  PunchType: filters.punchType,
  LocationName: filters.locationName,
  EntityName: filters.entityName,
  EntityType: filters.entityType,
  RecordedBy: filters.recordedBy,
  Remarks: filters.remarks,
  ViewType: filters.viewType,
  DeviceBased: filters.deviceBased,
});

const employeePunchesApi = {
  getEmployeePunches: async (filters: FilterValues): Promise<EmployeePunchReportItem[]> => {
    const response = await api.get<EmployeePunchReportItem[]>('/EmployeePunches/view-total-punch', {
      params: buildParams(filters),
    });
    return response.data;
  },

  getWhosInEmployee: async (filters: FilterValues): Promise<EmployeePunchReportItem[]> => {
    const response = await api.get<EmployeePunchReportItem[]>('/EmployeePunches/whos-in-employee-wise', {
      params: buildParams(filters),
    });
    return response.data;
  },

  getWhosInGroup: async (filters: FilterValues): Promise<EmployeePunchReportItem[]> => {
    const response = await api.get<EmployeePunchReportItem[]>('/EmployeePunches/whos-in-group-wise', {
      params: buildParams(filters),
    });
    return response.data;
  },

  getMobileCheckinReport: async (filters: FilterValues): Promise<MobileCheckinReportItem[]> => {
    const response = await api.get<MobileCheckinReportItem[]>('/EmployeePunches/mobile-checkin-report', {
      params: buildParams(filters),
    });
    return response.data;
  },
};

export default employeePunchesApi;
